'use client';

import { Card, cardTag } from '@ni/nimble-components/dist/esm/card';
import { wrap } from '../utilities/react-wrapper';

export { cardTag };
export { type Card };
export const NimbleCard = wrap(Card);
